import {inject, Injectable} from "@angular/core";
import {mergeWith, Observable, of} from "rxjs";
import {NavigationEnd, Router} from "@angular/router";
import {filter, map} from "rxjs/operators";
import {BreadcrumbPath} from "../../shared/ui/breadcrumb/breadcrumb.component";

@Injectable({providedIn: 'root'})

export class CoreDomainService {
    private readonly router = inject(Router)
    private readonly breadcrumbdata= {
                                                                '':                                 [{label:'Mes collaborateurs directs'}],
                                                                '/mon-equipe':                      [{label:'Mes collaborateurs directs'}],
                                                                '/mon-equipe/nouveau-collaborateur':[{label:'Mes collaborateurs directs', lien: '/mon-equipe'},
                                                                                                     {label: 'Ajouter un collaborateur'}],
                                                                '/mon-equipe/equipe-globale':       [{label:'Mon équipe globale'}],
                                                                '/managers/update':                 [{label:'Mettre à jour le manager (à la place du manager)'}],
                                                                '/changement-manager':              [{label:'Confirmer les valideurs après le changement de manager'}],
                                                                '/valideurs/update':                [{label:'Mettre à jour les valideurs (sans changement de manager)'}],
                                                                '/valideurs/consultation':          [{label:'Visualiser les valideurs'}],
                                                                '/organigramme':                    [{label:'Visualiser l\'organigramme'}],
                                                                '/organigramme/exporter-delegations':[{label:'Organigramme', lien: '/organigramme'},
                                                                                                      {label:'Exporter les délégations'}],
                                                                '/comites':                         [{label:'Visualiser les comités'}],
                                                                '/comites/comites-membres':         [{label:'Comités', lien: '/comites'},
                                                                                                     {label:'Mettre à jour les membres des comités'}]
                                                             }

    breadcrumbDatas$: Observable<BreadcrumbPath> = this.router.events.pipe(
        filter((event) => event instanceof NavigationEnd),
        mergeWith(
            of({
                url: this.router.url,
            }),
        ),
        map((navigEvent) => {
            const path = (navigEvent as NavigationEnd).url.split('?')[0]
            return this.breadcrumbdata[path]
        }),
    )
}
